export enum IntermediateCatchEventImplPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    /**
     * 驳回规则
     */
    BackWardRule = 'BackWardRule',
    EventDefinitions = 'EventDefinitions',
    variableSettings = 'variableSettings',
}